import * as core from '../../../../../../../core'

import { query } from './goals-table.query'

export const RESOURCE = {
  payload: {
    alias: 'playground.goals-table',
    description:
      'Table of Goal records; clicking a row opens the assistant slideout, ' +
      'authorized to retrieve that record for the duration of the session',
    name: 'Playground - Goals Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
